import { Button, Image, Typography } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

import { DEVICE } from '@hero/constants';

const Advantages = styled.div`
  background-color: var(--color-bg-stronger);
  display: flex;
  flex-direction: column;
  padding: 40px 16px 40px 16px;
  width: 100%;

  ${Typography?.S?.Typography} {
    color: var(--color-fg-inverse-default);
  }

  ${DEVICE.tablet.mid} {
    height: fit-content;
  }
  ${DEVICE.mobile.max} {
    padding: var(--size-padding-24) var(--size-padding-16);
  }
`;
const AdvantagesList = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: var(--size-gap-24);
  gap: 24px;
  justify-content: center;
  padding: 0 var(--size-gap-24);

  ${DEVICE.mobile.max} {
    gap: 16px;
    margin-top: var(--size-gap-40);
    padding: 0;
  }
`;
const AdvantagesItem = styled.div`
  align-items: center;
  display: flex;
  gap: 16px;

  ${DEVICE.mobile.max} {
    margin-top: 0;
  }
`;
const AdvantagesItemIcon = styled.div`
  background-color: var(--color-bg-default);
  border-radius: 50%;
  display: grid;
  height: 48px;
  min-width: 48px;
  place-items: center;
`;
const AdvantagesItemInfo = styled.div``;

const AdvantagesVideo = styled.div`
  height: 250px;
  margin-bottom: 40px;
  margin-top: 16px;
  position: relative;

  .video-react {
    min-width: 444px;
  }

  ${DEVICE.tablet.max} {
    .video-react {
      min-width: 100%;
    }
  }
  ${Image?.S?.Image} {
    width: 444px;
  }
  .video-react-big-play-button {
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  ${Button.S.Button} {
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
  }

  ${DEVICE.mobile.max} {
    height: 174px;

    ${Image.S.Image} {
      height: auto;
      width: 100%;
    }
  }

  ${DEVICE.tablet.max} {
    height: auto;

    ${Image.S.Image} {
      height: auto;
      width: 100%;
    }
  }
`;
export {
  Advantages,
  AdvantagesItem,
  AdvantagesItemIcon,
  AdvantagesItemInfo,
  AdvantagesList,
  AdvantagesVideo
};
